import Validatecode from './validateCode';
import { SIZE } from './constants';

export default Validatecode;
export { SIZE };